import ko from '@tko/build.knockout';
import templateMarkup from 'raw-loader!./title-widget.html';

  function TitleWidget(params) {
      var self = this;
      this.observableOptions = params.observableOptions;
      this.observableData = params.observableData;
      self.panelTemplate = params.panelTemplate;

      self.title = ko.observable('');
      self.message = ko.observable('');

      self.dataLoaded = ko.observable(false);
      self.RefreshData();

      self.subscriptions = [];
      self.subscriptions.push(self.observableData.subscribe(function () { self.DataUpdated(); }));
      //self.subscriptions.push(self.observableOptions.subscribe(function () { self.OptionsUpdated(); }));
  }


  TitleWidget.prototype.RefreshData = function () {
      var self = this;

      var data = self.observableData();

      if (!$.isEmptyObject(data)) {
          if (data.title)
              self.title(data.title);

          if (data.message)
              self.message(data.message);
          self.dataLoaded(true);
      }
  };

  TitleWidget.prototype.DataUpdated = function () {
      var self = this;
      self.RefreshData();
  };

  TitleWidget.prototype.OptionsUpdated = function () {
      var self = this;
      self.RefreshData();
  };

  // This runs when the component is torn down. Put here any logic necessary to clean up,
  // for example cancelling setTimeouts or disposing Knockout subscriptions/computeds.
  TitleWidget.prototype.dispose = function() {
      var self = this;
      self.subscriptions.forEach(function (sub) {
          sub.dispose();
      });
  };
  
  export default { viewModel: TitleWidget, template: templateMarkup };


